var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t(
        "tablist",
        [
          _c(
            "div",
            { staticClass: "container flex overflow-x-auto" },
            _vm._l(_vm.tabs, function(tab) {
              return _c(
                "button",
                {
                  key: tab.id,
                  staticClass:
                    "px-6 py-2 text-lg cursor-pointer focus:outline-none",
                  class: tab.isActive
                    ? "text-dark bg-white font-medium"
                    : "hover:text-blue-1 text-gray-1",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.selectTab(tab)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                " + _vm._s(tab.name) + "\n            "
                  )
                ]
              )
            }),
            0
          )
        ],
        { tabs: _vm.tabs, selectTab: _vm.selectTab }
      ),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }